import React from "react";
import homeBackground from "../assets/img/fondo-home.png";
import AnimatedLogo from "../components/AnimatedLogo";
import "../styles/nosotros.css";

const Nosotros = () => {
  return (
    <div
      className="nosotros-container"
      style={{ backgroundImage: `url(${homeBackground})` }}
    >
      {/* <section className="hero-nosotros">
        <h1>Quiénes Somos</h1>
        <p>
          Comprometidos con la excelencia, la transparencia y el desarrollo
          profesional.
        </p>
      </section> */}
      <AnimatedLogo />
      {/* <section className="nosotros-section">
        <h2>Nuestra Historia</h2>
        <p>
          Somos una institución dedicada a promover la formación, la ética y el
          crecimiento profesional dentro del sector. A lo largo de los años
          hemos construido un equipo comprometido y una estructura sólida que
          respalda proyectos y servicios de alto impacto.
        </p>
      </section> */}

      <section className="nosotros-section">
        <h2>Misión</h2>
        <p>
          Promover el desarrollo técnico, científico y profesional de la ingeniería sanitaria y ambiental, mediante la representación y articulación de sus profesionales, la capacitación continua, la investigación y la generación de conocimiento, asi como el aporte técnico a la gestión sectorial y a las politicas públicas, con el fin de contribuir de manera efectiva a la mejora de la salud pública, la protección del calidad de vida de la población.
        </p>
      </section>

      <section className="nosotros-section">
        <h2>Visión</h2>
        <p>
          Ser una institución técnica y ética de referencia en los ámbitos departamental, nacional e internacional, reconocida por su aporte al fortalecimiento del saneamiento băsico y la gestión integral del agua, asi como por su liderazgo en la generación y difusión de conocimiento, la formación especializada y el aporte técnico a las politicas públicas en ingenieria sanitaria y ambiental, contribuyendo de manera efectiva a la mejora de la salud pública y a la protección del medio ambiente.
        </p>
      </section>
    </div>
  );
};

export default Nosotros;
